import { getJourneyBySlug } from "./giftJourney";

const pic = (seed) => `https://picsum.photos/seed/gk-${seed}/1200/800`;

/** Background + corners for checkout / product flow when `gifts/` has no images. */
export const ECARD_VISUAL_PRESETS = {
  egift: {
    main: pic("egift-main"),
    corner1: pic("egift-c1"),
    corner2: pic("egift-c2"),
  },
  anniversary: {
    main: pic("anniv-main"),
    corner1: pic("anniv-c1"),
    corner2: pic("anniv-c2"),
  },
  birthday: {
    main: pic("bday-main"),
    corner1: pic("bday-c1"),
    corner2: pic("bday-c2"),
  },
  invitation: {
    main: pic("inv-main"),
    corner1: pic("inv-c1"),
    corner2: pic("inv-c2"),
  },
  proposal: {
    main: pic("prop-main"),
    corner1: pic("prop-c1"),
    corner2: pic("prop-c2"),
  },
  "missing-message": {
    main: pic("miss-main"),
    corner1: pic("miss-c1"),
    corner2: pic("miss-c2"),
  },
};

const PRESET_KEYS = new Set(Object.keys(ECARD_VISUAL_PRESETS));

function normalizePresetKey(raw) {
  const s = String(raw || "")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, "-");
  if (PRESET_KEYS.has(s)) return s;
  return "egift";
}

/**
 * Resolves which visual bucket to use: explicit `ecardPreset` on the gift,
 * or the occasion slug from the URL (`?occasion=`).
 */
export function resolveVisualPresetKey(summary, occasionSlug) {
  if (summary?.ecardPreset && PRESET_KEYS.has(normalizePresetKey(summary.ecardPreset))) {
    return normalizePresetKey(summary.ecardPreset);
  }
  const fromJourney = getJourneyBySlug(occasionSlug || "egift").slug;
  if (PRESET_KEYS.has(fromJourney)) return fromJourney;
  return "egift";
}

const FORMAT_BY_PRESET = {
  egift: "minimalNavy",
  anniversary: "romanticFrame",
  birthday: "celebrationBurst",
  invitation: "elegantIvory",
  proposal: "proposalSparkle",
  "missing-message": "gentleMist",
};

/**
 * Shape expected by ProductCard, checkout, Razorpay, and GiftDetails save payload.
 */
export function mergeSummaryWithVisualPreset(summary, occasionSlug) {
  if (!summary) return null;
  const key = resolveVisualPresetKey(summary, occasionSlug);
  const v = ECARD_VISUAL_PRESETS[key] || ECARD_VISUAL_PRESETS.egift;
  const cover = (summary.coverUrl || "").trim();
  const img2 = (summary.image2 || "").trim();
  const img3 = (summary.image3 || "").trim();
  return {
    id: summary.id,
    Tittle: summary.name,
    Description: summary.description,
    Price: summary.price,
    Discount: summary.discount,
    Validity: summary.validityLabel || summary.validity || "",
    validityMonths: summary.validityMonths,
    expiresAtMs: summary.expiresAtMs,
    formatId: FORMAT_BY_PRESET[key] || FORMAT_BY_PRESET.egift,
    imageurl: cover || v.main,
    image2: img2 || v.corner1,
    image3: img3 || v.corner2,
    _presetKey: key,
  };
}
